import { DEFAULT_COOKIE_CONFIG } from '@constants/cookie.constants';
import { default as Cookies } from 'js-cookie';

export const getCookieValue = (cookieKey: string): string | undefined => Cookies.get(cookieKey);

export const setCookieValue = (
	cookieKey: string,
	value: string,
	config?: Cookies.CookieAttributes,
): string | undefined => Cookies.set(cookieKey, value, { ...DEFAULT_COOKIE_CONFIG, ...config });

export const deleteCookie = (cookieKey: string): void => Cookies.remove(cookieKey);
